import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = ["aria-busy"]
const _hoisted_2 = {
  key: 0,
  class: "loading"
}
const _hoisted_3 = {
  key: 1,
  class: "loading"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loader = _resolveComponent("loader")!
  const _component_link_back = _resolveComponent("link-back")!
  const _component_button_action = _resolveComponent("button-action")!
  const _component_error_message = _resolveComponent("error-message")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["loading-container col px-0", _ctx.compact ? '' : 'loading-container-large']),
    "aria-live": "polite",
    "aria-busy": _ctx.state === 'loading'
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["d-flex align-items-center flex-column w-100", { 'loading-small': _ctx.small}])
    }, [
      (_ctx.state === 'loading' && !_ctx.compact && !_ctx.small)
        ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(_ctx.$t('common.loadingLong')), 1))
        : _createCommentVNode("", true),
      (_ctx.state === 'loading' && _ctx.compact && !_ctx.small)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_3, _toDisplayString(_ctx.$t('common.loadingLong')), 1))
        : _createCommentVNode("", true),
      (_ctx.state === 'loading')
        ? (_openBlock(), _createBlock(_component_loader, {
            key: 2,
            i18nMessage: _ctx.i18nLoadingMessage,
            class: _normalizeClass({ 'loader-small': _ctx.small})
          }, null, 8, ["i18nMessage", "class"]))
        : _createCommentVNode("", true),
      (_ctx.state === 'error')
        ? (_openBlock(), _createBlock(_component_error_message, {
            key: 3,
            i18nMessage: _ctx.i18nErrorMessage,
            "error-uuid": _ctx.errorUuid,
            class: "mt-4"
          }, {
            default: _withCtx(() => [
              (_ctx.state === 'error' && _ctx.errorLinkTo)
                ? (_openBlock(), _createBlock(_component_link_back, {
                    key: 0,
                    to: _ctx.errorLinkTo,
                    i18nMessage: _ctx.i18nErrorLinkMessage,
                    class: "mt-2"
                  }, null, 8, ["to", "i18nMessage"]))
                : _createCommentVNode("", true),
              (_ctx.state === 'error' && _ctx.showClearErrorRequestLink)
                ? (_openBlock(), _createBlock(_component_button_action, {
                    key: 1,
                    "i18n-message": "common.understood",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clearErrorRequested'))),
                    class: "mt-4",
                    "btn-outline": true,
                    "btn-css-color-class": _ctx.buttonUnderStoodClass
                  }, null, 8, ["btn-css-color-class"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["i18nMessage", "error-uuid"]))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.state === 'success')
      ? _renderSlot(_ctx.$slots, "default", { key: 0 }, undefined, true)
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}